var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          staticClass: "mb-0",
          attrs: {
            label: "Findings",
            "label-cols-sm": "4",
            "label-class": "pt-0"
          }
        },
        _vm._l(_vm.fieldIds.findings, function(fieldId) {
          return _c(
            "b-check",
            {
              key: fieldId,
              staticClass: "scrawl-checkbox",
              attrs: {
                size: "lg",
                value: _vm.fieldToIdMap[fieldId],
                "unchecked-value": null
              },
              model: {
                value: _vm.selection.findings,
                callback: function($$v) {
                  _vm.$set(_vm.selection, "findings", $$v)
                },
                expression: "selection.findings"
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.fieldToTitleMap[fieldId]) +
                  "\n        "
              )
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.sideVisible
            ? _c(
                "b-form-group",
                {
                  staticClass: "mt-3 mb-0",
                  attrs: {
                    label: "Side",
                    "label-cols-sm": "4",
                    "label-class": "pt-0"
                  }
                },
                _vm._l(_vm.fieldIds.sides, function(fieldId) {
                  return _c(
                    "b-check",
                    {
                      key: fieldId,
                      staticClass: "scrawl-checkbox",
                      attrs: {
                        size: "lg",
                        value: _vm.fieldToIdMap[fieldId],
                        "unchecked-value": null
                      },
                      model: {
                        value: _vm.selection.sides,
                        callback: function($$v) {
                          _vm.$set(_vm.selection, "sides", $$v)
                        },
                        expression: "selection.sides"
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.fieldToTitleMap[fieldId]) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.ihVisible
            ? _c(
                "b-form-group",
                {
                  staticClass: "mt-3 mb-0",
                  attrs: {
                    label: "Haemorrhage site",
                    "label-cols-sm": "4",
                    "label-class": "pt-0"
                  }
                },
                _vm._l(_vm.fieldIds.ih, function(fieldId) {
                  return _c(
                    "b-check",
                    {
                      key: fieldId,
                      staticClass: "scrawl-checkbox",
                      attrs: {
                        size: "lg",
                        value: _vm.fieldToIdMap[fieldId],
                        "unchecked-value": null
                      },
                      model: {
                        value: _vm.selection.ih,
                        callback: function($$v) {
                          _vm.$set(_vm.selection, "ih", $$v)
                        },
                        expression: "selection.ih"
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.fieldToTitleMap[fieldId]) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.aiVisible
            ? _c(
                "b-form-group",
                {
                  staticClass: "mt-3 mb-0",
                  attrs: {
                    label: "Infarction site",
                    "label-cols-sm": "4",
                    "label-class": "pt-0"
                  }
                },
                _vm._l(_vm.fieldIds.ai, function(fieldId) {
                  return _c(
                    "b-check",
                    {
                      key: fieldId,
                      staticClass: "scrawl-checkbox",
                      attrs: {
                        size: "lg",
                        value: _vm.fieldToIdMap[fieldId],
                        "unchecked-value": null
                      },
                      model: {
                        value: _vm.selection.ai,
                        callback: function($$v) {
                          _vm.$set(_vm.selection, "ai", $$v)
                        },
                        expression: "selection.ai"
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.fieldToTitleMap[fieldId]) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.aiLacuneVisible
            ? _c(
                "b-form-group",
                {
                  staticClass: "mt-3 mb-0",
                  attrs: {
                    label: "Infarction lacune site",
                    "label-cols-sm": "4",
                    "label-class": "pt-0"
                  }
                },
                _vm._l(_vm.fieldIds.ai_lacune, function(fieldId) {
                  return _c(
                    "b-check",
                    {
                      key: fieldId,
                      staticClass: "scrawl-checkbox",
                      attrs: {
                        size: "lg",
                        value: _vm.fieldToIdMap[fieldId],
                        "unchecked-value": null
                      },
                      model: {
                        value: _vm.selection.ai_lacune,
                        callback: function($$v) {
                          _vm.$set(_vm.selection, "ai_lacune", $$v)
                        },
                        expression: "selection.ai_lacune"
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.fieldToTitleMap[fieldId]) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.telestrokeMode
        ? _c(
            "b-form-group",
            {
              staticClass: "mt-3 mb-0",
              attrs: {
                label: "Additional findings",
                "label-cols-sm": "4",
                "label-class": "pt-0"
              }
            },
            _vm._l(_vm.fieldIds.add_findings, function(fieldId) {
              return _c(
                "b-check",
                {
                  key: fieldId,
                  staticClass: "scrawl-checkbox",
                  attrs: { size: "lg", value: _vm.fieldToIdMap[fieldId] },
                  model: {
                    value: _vm.selection.add_findings,
                    callback: function($$v) {
                      _vm.$set(_vm.selection, "add_findings", $$v)
                    },
                    expression: "selection.add_findings"
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.fieldToTitleMap[fieldId]) +
                      "\n        "
                  )
                ]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Notes" } },
        [
          _c("b-form-textarea", {
            attrs: { rows: "3" },
            model: {
              value: _vm.notes,
              callback: function($$v) {
                _vm.notes = $$v
              },
              expression: "notes"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.debugMode
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("small", { staticClass: "form-text text-muted" }, [
                  _c("span", { staticClass: "text-monospace" }, [
                    _vm._v(_vm._s(_vm.selection))
                  ])
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "form-text text-muted" }, [
                  _c("span", { staticClass: "text-monospace" }, [
                    _vm._v("stay: " + _vm._s(_vm.results))
                  ])
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "form-text text-muted" }, [
                  _c("span", { staticClass: "text-monospace" }, [
                    _vm._v("local: " + _vm._s(_vm.localResults))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    staticClass: "mt-2",
                    attrs: { variant: "outline-danger", size: "sm" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.clearResults.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("Clear Results")]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }